import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

const RecapAchat = ({ TotalPrixHT, recapTva }) => {
  const totalTva = recapTva.reduce((sum, item) => sum + item.montant, 0);
  return (
    <Card>
      <Card.Body>
        <div
          style={{
            height: '210px',
            // width: '90%',
            padding: '10px', // Add padding for inner spacing
            border: '1px solid #e0e0e0', // Light gray border for all sides
            borderTop: '5px solid blue' // Blue top border
          }}
        >
          <div
            className="d-flex justify-content-between  pb-2"
            style={{ borderBottom: '1px solid #e0e0e0' }}
          >
            <span className="fw-semibold">Total HT</span>
            <span className="fw-semibold">
              {TotalPrixHT?.toFixed(3) || '0.000'} DT
            </span>
          </div>
          <div
            className="d-flex justify-content-between py-2"
            style={{ borderBottom: '1px solid #e0e0e0' }}
          >
            <span className="fw-semibold">Total TVA</span>
            <span className="fw-semibold">
              {totalTva?.toFixed(3) || '0.000'} DT
            </span>
          </div>
          <div
            className="d-flex justify-content-between  py-2"
            style={{ borderBottom: '1px solid #e0e0e0' }}
          >
            <span className="fw-semibold">Total TTC</span>
            <span className="fw-semibold">
              {(TotalPrixHT + totalTva).toFixed(3) || '0.000'} DT
            </span>
          </div>
          <div
            className="d-flex justify-content-between  py-2"
            style={{ borderBottom: '1px solid #e0e0e0' }}
          >
            <span className="fw-semibold">timbre Fiscal</span>
            <span className="fw-semibold">{'1.800'} DT</span>
          </div>
          <div className="d-flex justify-content-between  py-2">
            <span className="fw-semibold">Net à payer</span>
            <span className="fw-semibold">
              {(TotalPrixHT + totalTva + 1.8).toFixed(3) || '0.000'} DT
            </span>
          </div>
        </div>
      </Card.Body>
      <Card.Body>
        <div
          style={{
            padding: '10px',
            border: '1px solid #e0e0e0', // Light gray border for all sides
            borderTop: '5px solid blue' // Blue top border
          }}
        >
          <Row className="mb-2 fw-bold">
            <Col className="text-center">
              <span className="fw-semibold">TVA</span>
            </Col>
            <Col className="text-start">
              <span className="fw-semibold text-start">Base</span>
            </Col>
            <Col>
              <span className="fw-semibold">Montant</span>
            </Col>
          </Row>
          {recapTva.map((item, index) => (
            <Row key={index}>
              <Col className="text-center">{item.tva}</Col>
              <Col className="text-start">{item.base.toFixed(3)}</Col>
              <Col className="text-end">{item.montant.toFixed(3)}</Col>
            </Row>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

RecapAchat.propTypes = {
  TotalPrixHT: PropTypes.number, // Correctly define the prop type for "recap"
  recapTva: PropTypes.array
};

export default RecapAchat;
